import { render, staticRenderFns } from "@/components/Layout/Menu/SideBar/SideBar.html?vue&type=template&id=bafaf22c&scoped=true&"
import script from "@/components/Layout/Menu/SideBar/SideBar.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/SideBar/SideBar.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/SideBar/SideBar.css?vue&type=style&index=0&id=bafaf22c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafaf22c",
  null
  
)

export default component.exports